import { render, staticRenderFns } from "./htc-brand.vue?vue&type=template&id=2753c012"
import script from "./htc-brand.vue?vue&type=script&lang=js"
export * from "./htc-brand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports